import React from 'react';

import { Heading, Box, SimpleGrid, useBreakpointValue } from '@chakra-ui/core';
import Slider from 'react-slick';

import { connect } from 'react-redux';
import { getRestaurants, getCategories } from '../redux/actions/restAction';

//?util
import Head from '../util/Head';

import Hero from '../components/home/Hero';
import Rec from '../components/home/Rec';
import Commande from '../components/home/Commande';
import Ville from '../components/home/Ville';
// import Mobile from '../components/home/Mobile';
// import Description from '../components/home/Description';

function Home(props) {
  const base = useBreakpointValue({ base: true, md: false });

  React.useEffect(() => {
    async function data() {
      await props.getCategories();
      await props.getRestaurants();
    }
    data();
  }, []);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    // swipeToSlide: true,
    centerPadding: '10px',
    className: 'center',
    centerMode: true,
    // nextArrow: <SampleNextArrow />,
    responsive: [
      //   {
      //     breakpoint: 1800,
      //     settings: {
      //       slidesToShow: 4,
      //       slidesToScroll: 4,
      //       infinite: true,
      //       dots: true,
      //     },
      //   },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          //   initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Box>
      <Head title="Yakool"></Head>
      <Hero></Hero>
      <Box className="lower-container" pl="15px" pr="15px">
        <Box p={['20px', '30px', '30px', '30px']}>
          <Box position="relative" textAlign="center">
            <Box
              w="100%"
              position={['none', 'none', 'absolute', 'absolute']}
              textAlign="center"
            >
              <Heading
                // m="0 auto"
                fontFamily="Rubik Mono One"
                p="15px"
                size="lg"
              >
                Vos commerçants préférés sont sur Yakool
              </Heading>
            </Box>
          </Box>
          {props.posts && (props.posts.length < 3 || base) ? (
            <SimpleGrid
              spacing={10}
              justifyItems="center"
              columns={[1, 2, 3, 4]}
            >
              {props.posts.map(post => {
                return (
                  <Rec
                    key={post.id}
                    latitude={post.latitude}
                    prix={post.prix}
                    longitude={post.longitude}
                    id={post.id}
                    name={post.name}
                    adress={post.adress}
                    image={`${process.env.REACT_APP_API}/storage/${post.image}`}
                  ></Rec>
                );
              })}
            </SimpleGrid>
          ) : (
            <Slider style={{ margin: '0 auto' }} {...settings}>
              {props.posts &&
                props.posts.map(post => {
                  return (
                    <Box key={post.id} p="4">
                      <Rec
                        latitude={post.latitude}
                        prix={post.prix}
                        rate={post.rate}
                        longitude={post.longitude}
                        id={post.id}
                        name={post.name}
                        adress={post.adress}
                        image={`${process.env.REACT_APP_API}/storage/${post.image}`}
                      ></Rec>
                    </Box>
                  );
                })}
            </Slider>
          )}
        </Box>
        <Box p={['20px', '30px', '40px', '50px']}>
          <Box textAlign="center">
            <Heading fontFamily="Rubik Mono One" p="15px" mb="4" size="lg">
              Vos commerçants préférés sont sur Yakool
            </Heading>
          </Box>
          <Commande cartegories={props.cat}></Commande>
        </Box>
        <Box textAlign="center" p={['20px', '30px', '40px', '50px']}>
          <Heading fontFamily="Rubik Mono One" mb="4" p="15px" size="lg">
            Yakool est dans les plus belles villes
          </Heading>
          <Ville></Ville>
        </Box>
      </Box>
    </Box>
  );
}
const mapStateToProps = state => {
  return {
    posts: state.rest.posts,
    cat: state.rest.cartegories,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCategories: () => dispatch(getCategories()),
    getRestaurants: () => dispatch(getRestaurants()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

// export async function getStaticProps() {
//   // Call an external API endpoint to get posts.
//   // You can use any data fetching library
//   const res = await fetch(
//     `${process.env.REACT_APP_API}/api/restaurants?apiKey=azerty&limit=50&offset=0`
//   );
//   const catres = await fetch(`${process.env.REACT_APP_API}/api/allCategories`);
//   const posts = await res.json();
//   const cat = await catres.json();
//   //   (cat);

//   // By returning { props: posts }, the Blog component
//   // will receive `posts` as a prop at build time
//   return {
//     props: {
//       posts,
//       cat,
//     },
//   };
// }
